module.exports = __webpack_public_path__ + "img/hest_camp.cf196a18.jpg";